import React from 'react'
// Time-clock badge catalog + chip — shared by the kiosk and the dashboard
// self-views (/timeclock/me). The catalog is a module-level singleton
// refreshed by fetchBadgeCatalog() (fired on mount in both entries).
// Extracted from cutting-dashboard.jsx for the kiosk bundle split.
const BADGES_FALLBACK = {
  EARLY_BIRD:       { label: 'Early Bird',        icon: '🌅', desc: 'Clocked in before 7am.',                 color: '#fbbf24' },
  NIGHT_OWL:        { label: 'Night Owl',         icon: '🦉', desc: 'Clocked out after 7pm.',                 color: '#a78bfa' },
  IRON_WILL:        { label: 'Iron Will',         icon: '💪', desc: 'Worked over 9 hours in one day.',        color: '#10b981' },
  POWER_LUNCH:      { label: 'Power Lunch',       icon: '⚡', desc: 'Lunch under 35 minutes.',                color: '#06d4f0' },
  GOURMAND:         { label: 'Gourmand',          icon: '🍝', desc: 'Lunch over an hour.',                    color: '#f87171' },
  PUNCTUAL:         { label: 'First In',          icon: '🥇', desc: 'First to clock in today.',               color: '#fbbf24' },
  WEEKEND_WARRIOR:  { label: 'Weekend Warrior',   icon: '⚔️', desc: 'Clocked in on a weekend.',               color: '#06d4f0' },
  CANT_STOP_WORKING:{ label: "Can't Stop Working",icon: '🔥', desc: 'Worked over 40 hours in a single week.', color: '#fb923c' },
  HIGH_FIVE:        { label: 'High Five',         icon: '🖐️', desc: 'Five on-time clock-ins in a row.',       color: '#06d4f0' },
  PERFECT_TEN:      { label: 'Perfect 10',        icon: '💯', desc: 'Ten on-time clock-ins in a row.',        color: '#10b981' },
  UNTOUCHABLE:      { label: 'Untouchable',       icon: '🛡️', desc: 'Twenty on-time clock-ins in a row.',     color: '#a78bfa' },
  EXACT_FORTY:      { label: 'Exact 40',          icon: '🎯', desc: 'Worked exactly 40 hours in a week.',     color: '#06d4f0' },
  BACK_TO_BACK:     { label: 'Back-to-Back',      icon: '🔗', desc: 'Full 5-day week with no missed shifts and no late punches.', color: '#10b981' },
  DOOR_DASHER:      { label: 'Door Dasher',       icon: '🚪', desc: 'Three short-shift warning overrides in one pay period.',     color: '#f87171' },
  CONSISTENT:       { label: 'Consistent',        icon: '⚖️', desc: 'Same clock-in time within five minutes for five consecutive days.', color: '#06d4f0' },
  VAMPIRE:          { label: 'Vampire',           icon: '🦇', desc: 'All clock-ins after noon for an entire week.',                color: '#a78bfa' },
  FENCE_SITTER:     { label: 'Fence Sitter',      icon: '🧱', desc: 'Four straight weeks at 39-41 hours — never above, never below.', color: '#94a3b8' },
  OPENER:           { label: 'Opener',            icon: '🔑', desc: 'First in for five days running.',         color: '#fbbf24' },
  CLOSER:           { label: 'Closer',            icon: '🔒', desc: 'Last out for five days running.',         color: '#a78bfa' },
}
// Mutable cache of server-supplied badge metadata. Refreshed by
// fetchBadgeCatalog() on app mount + when admin edits land. Lookups
// merge over BADGES_FALLBACK so a missing/inactive code still has copy.
let _badgeCatalog = null
export function getBadge(code) {
  if (_badgeCatalog && _badgeCatalog[code]) return _badgeCatalog[code]
  return BADGES_FALLBACK[code] || { label: code, icon: '🏅', desc: '', color: '#94a3b8' }
}
export async function fetchBadgeCatalog() {
  try {
    const res = await fetch('/api/timeclock/badges')
    if (!res.ok) return
    const rows = await res.json()
    const map = {}
    for (const r of rows) {
      map[r.code] = { label: r.label, icon: r.icon || '🏅', desc: r.description || '', color: r.color || '#94a3b8', active: !!r.active }
    }
    _badgeCatalog = map
  } catch { /* fallback to hardcoded — no-op */ }
}
// Backward-compat shim — anything still reading BADGES.X gets the
// merged value transparently. Keep until all call sites use getBadge().
export const BADGES = new Proxy({}, { get: (_t, k) => getBadge(String(k)) })

export function BadgeChip({ code, count, isNew, big }) {
  const meta = BADGES[code]
  if (!meta) return null
  return (
    <span title={meta.desc + (count > 1 ? ` (earned ${count}×)` : '')}
          style={{
            display:'inline-flex', alignItems:'center', gap:5,
            padding: big ? '6px 12px' : '4px 8px',
            fontSize: big ? 13 : 11, fontWeight:700, letterSpacing:'.04em',
            background: `${meta.color}1a`, color: meta.color,
            border: `1px solid ${meta.color}66`, borderRadius: 999,
            fontFamily: 'inherit',
            boxShadow: isNew ? `0 0 12px ${meta.color}55` : 'none',
          }}>
      <span style={{fontSize: big ? 16 : 13}}>{meta.icon}</span>
      <span>{meta.label}</span>
      {count > 1 && <span style={{opacity:.6,fontWeight:500}}>×{count}</span>}
    </span>
  )
}
